import "./index.css";
import "./logger";

import React from "react";
import ReactDOM from "react-dom/client";

import { Whole } from "./site";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Whole />
  </React.StrictMode>
);
